import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-add-course',
  templateUrl: './add-course.component.html',
  styleUrls: ['./add-course.component.scss']
})
export class AddCourseComponent implements OnInit {
  public courseForm!: FormGroup;
  public isUpdate = false;
  public courseId = '';
  public fileName = 'No file chosen';
  public isLoading = false;

  public readonly courseCategories = [
    'Clinical Chemistry',
    'Clinical Pathology',
    'Hematology',
    'Immunoassay',
    'Quality Assurance',
    'Samples & Pre-Analytics',
    'Micro-Biology',
    'General',
    'Transfusion Medicine'
  ];

  constructor(
    private courseService: CourseService,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.checkUpdateMode();
  }

  private initializeForm(): void {
    this.courseForm = new FormGroup({
      title: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      thumbnail: new FormControl('', Validators.required),
      price: new FormControl('', Validators.required),
      prerequisite: new FormControl('', Validators.required),
      category: new FormControl('', Validators.required),
      duration: new FormControl('', Validators.required),
      toWhom: new FormControl('', Validators.required),
      toLearn: new FormControl('', Validators.required)
    });
  }

  private checkUpdateMode(): void {
    const urlParts = this.router.url.split('/');

    if (!urlParts.includes('modify')) {
      return;
    }

    this.courseId = urlParts[2];
    this.isUpdate = true;

    this.courseService.getCourse(this.courseId).subscribe(
      (res: any) => {
        const { course } = res;

        this.fileName = course.thumbnail?.originalname || 'No file chosen';

        this.courseForm.patchValue({
          title: course.title,
          description: course.description,
          thumbnail: course.thumbnail,
          price: course.price,
          prerequisite: course.prerequisite,
          category: course.category,
          duration: course.duration,
          toWhom: course.toWhom,
          toLearn: course.toLearn
        });
      }
    );
  }

  onCreateCourse(): void {
    this.submitCourse(
      this.courseService.addCourse.bind(this.courseService),
      'Course added!'
    );
  }

  onUpdateCourse(): void {
    this.submitCourse(
      (data: FormData) =>
        this.courseService.updateCourse(data, this.courseId),
      'Course updated!'
    );
  }

  private submitCourse(
    apiCall: (data: FormData) => any,
    successMessage: string
  ): void {
    const formData = this.createFormData();

    if (!formData) {
      return;
    }

    this.isLoading = true;

    apiCall(formData).subscribe(
      () => {
        this.isLoading = false;
        this.toastrService.success(successMessage);
        history.back();
      },
      (error: any) => {
        this.isLoading = false;
        this.toastrService.error(error?.message);
      }
    );
  }

  private createFormData(): FormData | null {
    if (this.courseForm.invalid) {
      this.toastrService.error('Please fill all the fields!');
      return null;
    }

    const formData = new FormData();

    Object.entries(this.courseForm.value).forEach(([key, value]) => {
      formData.append(key, value as any);
    });

    return formData;
  }

  onFileUpload(event: any): void {
    const file = event?.target?.files?.[0];

    if (!file) {
      return;
    }

    this.fileName = file.name;
    this.courseForm.get('thumbnail')?.setValue(file);
  }

  onClickCancel(): void {
    history.back();
  }
}